export default __webpack_public_path__ + "static/inter-all-800-normal-ec3562bf6d6e6d95d60273d5cb18cb14.woff";